import { entityConfig } from "@ngrx/signals/entities";
import { Role } from "src/app/store/admin-signal/interfaces/role.interface";
import { type } from "@ngrx/signals";
import { Credential } from "src/app/store/admin-signal/interfaces/credential.interface";
import { ClientDetailResponseDto, MemberRepresentationDto } from "@api/user-app-service";
import { MultiSelectItem } from "src/app/interfaces/multi-select-item.interface";
import { AdminListItem } from "../interfaces/admin-list-item.interface";
import { ServerConnectionListItem } from "../interfaces/server-connection-list-item.interface";

interface AdminState {
  adminLastSession: string | undefined;
  adminCredentials: Credential[];
  availableRoles: Role[];
  formError: string;
  lastListPath: string;
  inviteOrganizationItems: MultiSelectItem[];
  inviteLoading: boolean;
  inviteSubmitting: boolean;
  serverConnectionCreateSubmitting: boolean;
  serverConnectionsLoading: boolean;
  serverConnectionsLoaded: boolean;
  serverConnections: ServerConnectionListItem[];
  selectedServerConnectionInternalId: string | null;
  selectedServerConnectionDetail: ClientDetailResponseDto | null;
  loadedServerConnectionId: string | null;
  pendingNewClientSecret: string | null;
  serverConnectionClientInternalIdHint: string | null;
  keycloakAdminLoaded: boolean;
}

export const adminsEnabledConfig = entityConfig({
  entity: type<AdminListItem>(),
  collection: "adminsEnabled",
  selectId: (entity: MemberRepresentationDto) => entity.id ?? "",
});

export const adminsDisabledConfig = entityConfig({
  entity: type<AdminListItem>(),
  collection: "adminsDisabled",
  selectId: (entity: MemberRepresentationDto) => entity.id ?? "",
});
export const adminRolesConfig = entityConfig({
  entity: type<Role>(),
  collection: "adminRoles",
});

export const initialState: AdminState = {
  adminLastSession: undefined,
  adminCredentials: [],
  availableRoles: [],
  formError: "",
  lastListPath: "",
  inviteOrganizationItems: [],
  inviteLoading: false,
  inviteSubmitting: false,
  serverConnectionCreateSubmitting: false,
  serverConnectionsLoading: false,
  serverConnectionsLoaded: false,
  serverConnections: [],
  selectedServerConnectionInternalId: null,
  selectedServerConnectionDetail: null,
  loadedServerConnectionId: null,
  pendingNewClientSecret: null,
  serverConnectionClientInternalIdHint: null,
  keycloakAdminLoaded: false,
};
